import { draftContinueEditingText, draftDiscardText } from './EditDraftButton.locstring.json';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { lazyOnEditDraftButtonClicked } from 'owa-mail-compose-actions';
import getDefaultDisposalType from 'owa-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import { InstrumentationContext } from 'owa-mail-store';
import { lazyDeleteItems } from 'owa-mail-triage-action';
import * as React from 'react';

const styles = require('./ConversationReadingPane.scss');
const classNames = require('classnames');

export interface EditDraftButtonProps {
    itemId: string;
    instrumentationContext: InstrumentationContext;
    className?: string;
}

@observer
export default class EditDraftButton extends React.Component<EditDraftButtonProps, any> {
    render() {
        const editButtonClassNames = classNames(styles.iconButton, styles.editDraftButton);

        return (
            <div className={classNames(styles.draftButtonContainer, this.props.className)}>
                <TooltipHost content={loc(draftContinueEditingText)}>
                    <IconButton
                        ariaLabel={loc(draftContinueEditingText)}
                        onClick={this.onEditDraft}
                        iconProps={{ iconName: ControlIcons.Edit }}
                        className={editButtonClassNames}
                        styles={{ icon: styles.enabledIconButton }}
                    />
                </TooltipHost>
                <TooltipHost content={loc(draftDiscardText)}>
                    <IconButton
                        ariaLabel={loc(draftDiscardText)}
                        onClick={this.onDelete}
                        iconProps={{ iconName: ControlIcons.Delete }}
                        className={styles.iconButton}
                        styles={{ icon: styles.enabledIconButton }}
                    />
                </TooltipHost>
            </div>
        );
    }

    private onEditDraft = (event: React.MouseEvent<unknown>) => {
        event.stopPropagation();
        lazyOnEditDraftButtonClicked.importAndExecute(this.props.itemId);
    };

    private onDelete = (event: React.MouseEvent<unknown>) => {
        event.stopPropagation();
        lazyDeleteItems.importAndExecute(
            [this.props.itemId],
            getDefaultDisposalType(this.props.itemId),
            [this.props.instrumentationContext],
            'ReadingPane'
        );
    };
}
